import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getAuth } from 'firebase/auth';

let db;
let app;

export function initializeFirebase() {
  const firebaseConfig = {
		apiKey: "AIzaSyALvg6YtDpKY3Wq-bCOdU6mwhz6_BGq2aQ",
		authDomain: "wh-nxj.firebaseapp.com",
		databaseURL: "https://wh-nxj-default-rtdb.firebaseio.com",
		projectId: "wh-nxj",
		storageBucket: "wh-nxj.firebasestorage.app",
		messagingSenderId: "937839419323",
		appId: "1:937839419323:web:303a0c3e8a1bbabd18ee9e"
	};

  app = initializeApp(firebaseConfig);

  db = getDatabase(app);

	return app;
}

export function getDb() {
  return db;
}

export function getApp() {
  return app;
}
